const $ = jQuery.noConflict();

class AnchorLinks {
    constructor(trigger, anchorsContainer, stickyElement) {
        this.trigger = $(trigger);
        this.anchorsContainer = $(anchorsContainer);
        this.stickyElement = $(stickyElement);
    }
    init() {
        this.bindEvents();
        this.handleScroll();
    }
    bindEvents() {
        this.trigger.on('click', this.toggleAnchorLinks.bind(this));
        this.anchorsContainer.find('.anchor').on('click', this.removeActiveClass.bind(this));
        $(window).on('scroll', this.handleScroll.bind(this));
    }
    toggleAnchorLinks() {
        this.anchorsContainer.toggleClass('active');
    }
    removeActiveClass() {
        this.anchorsContainer.removeClass('active')
    }
    handleScroll() {
        if (this.stickyElement && this.stickyElement.length > 0 && this.stickyElement[0]) {
            const elementTop = this.stickyElement[0].getBoundingClientRect().top;
            const windowWidth = window.innerWidth;
            const alertBar = document.querySelector('.alert-bar');
            const alertBarHeight = alertBar ? alertBar.offsetHeight : 0;
            if ((windowWidth < 1200 && elementTop <= ( 64 + alertBarHeight ) ) || (windowWidth >= 1200 && elementTop <= ( 104 + alertBarHeight ) ) ) {
                this.stickyElement.addClass('sticky-active');
            } else {
                this.stickyElement.removeClass('sticky-active');
            }
        }
    }
}

export default new AnchorLinks('.anchors-mb h3', '.anchors-mb', '.block-anchor-links');
